// Guest Mic Leveler — pure math shared by RemoteAudioTuner and its tests.
export const TARGET_DBFS = -20;
export const SILENCE_GATE_DBFS = -50;
export const MIN_GAIN = 0.4;   // −8 dB — tames a hot mic
export const MAX_GAIN = 3.5;   // +11 dB — lifts a quiet guest
const STEP = 0.35;             // fraction of the error corrected per tick (slow, no pumping)

export function rmsDbfs(samples) {
  let sum = 0;
  for (let i = 0; i < samples.length; i++) sum += samples[i] * samples[i];
  const rms = Math.sqrt(sum / Math.max(samples.length, 1));
  return 20 * Math.log10(Math.max(rms, 1e-6));
}

export function nextLevelerGain(currentGain, measuredDbfs) {
  if (measuredDbfs < SILENCE_GATE_DBFS) return currentGain; // silence/breath — hold
  const errorDb = TARGET_DBFS - measuredDbfs;
  const next = currentGain * 10 ** ((errorDb * STEP) / 20);
  return Math.min(MAX_GAIN, Math.max(MIN_GAIN, next));
}
